/** Height of the sticky top bar (without the dropdown menu, which overlays the page). */
function headerOffset(): number {
  const bar = document.querySelector("header > div");
  return bar ? bar.getBoundingClientRect().height : 0;
}

function targetTop(el: HTMLElement): number {
  return Math.max(0, el.getBoundingClientRect().top + window.scrollY - headerOffset());
}

/**
 * Smoothly scrolls a section to sit directly under the sticky top bar, then re-checks the
 * position once scrolling has settled and corrects it if the layout shifted on the way.
 */
export function scrollToSection(id: string): void {
  const el = document.getElementById(id);
  if (!el) return;

  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  window.scrollTo({ top: targetTop(el), behavior: reduce ? "auto" : "smooth" });

  let lastY = -1;
  let stableFrames = 0;
  const started = performance.now();

  const settle = () => {
    const y = window.scrollY;
    stableFrames = Math.abs(y - lastY) < 1 ? stableFrames + 1 : 0;
    lastY = y;

    if (stableFrames >= 6 || performance.now() - started > 2500) {
      const top = targetTop(el);
      if (Math.abs(window.scrollY - top) > 2) {
        window.scrollTo({ top, behavior: "auto" });
      }
      return;
    }
    requestAnimationFrame(settle);
  };

  requestAnimationFrame(settle);
}
